module.exports = __webpack_public_path__ + "img/IconoVinilAdherible.064dd434.png";